import styled from 'styled-components';
import { DialogActions } from '@material-ui/core';
import { COLORS } from 'constants/design';

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;
  justify-content: space-between;

  .moveButton {
    border: 1px solid ${COLORS.YELLOW};
    background-color: ${COLORS.YELLOW};
    color: ${COLORS.LIMED_SPURCE};
    &:hover {
      background-color: ${COLORS.YELLOW};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;
export const StyledDiv = styled.div`
  width: 549px;
  display: flex;
  flex-direction: column;
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
`;
